export default "__VITE_ASSET__b_YK3P$a__";